class PrivacyController {
    constructor($scope, $window) {
        this.name = 'privacy'

        this.$scope = $scope
        this.$window = $window
    }

    $onInit() {
        this.$window.scrollTo(0, 0)

        this.language = localStorage.getItem('tourists_lang') || 'EN'

        this.watchLanguage()
    }

    watchLanguage() {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.language = localStorage.getItem('tourists_lang') || 'EN'
            }
        })
    }
}

PrivacyController.$inject = ['$scope', '$window']

export default PrivacyController



// WEBPACK FOOTER //
// ./client/app/components/policies/privacy/privacy.controller.js